import { Skeleton } from "../../skeleton";
import { IProps } from "./auto-table-loading-cell.types";

const AutoTableLoadingCell = ({ width = "100%", height = 20 }: IProps) => {
    return <Skeleton height={height} width={width} />;
};

export { AutoTableLoadingCell };
